import {
  FilterMode,
  TenantProfileCreateMutationVariables,
  TenantProfile_OrderBy,
  TenantProfile,
  SortOrder,
  TenantProfile_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantProfileService = {
  createOne: buildCreateOne(
    (tenantProfileCreateVariables: TenantProfileCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantProfileCreate(
          tenantProfileCreateVariables
        );
        return result.tenantProfileCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantProfileOne({ id });
    return result.tenantProfileOne as TenantProfile;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantProfile_OrderBy[] | null = null,
    filter: TenantProfile_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantProfile_Filter | undefined;
    if (searchValue !== "") {
      where = {
        legalName: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantProfileListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ legalName: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantProfileListWithOffset
    ) as TenantProfile[];
    return { list, orderBy };
  },
};
